import * as React from "react";
import { SVGProps } from "react";
const SvgStandby = (props: SVGProps<SVGSVGElement>) => (
  <svg
    data-name="Ebene 1"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    {...props}
  >
    <path d="M24 42.04c-9.11 0-16.52-7.41-16.52-16.52 0-5.35 2.61-10.39 6.97-13.48l1.73 2.45a13.56 13.56 0 0 0-5.71 11.04c0 7.46 6.06 13.52 13.52 13.52s13.52-6.07 13.52-13.52c0-4.46-2.2-8.64-5.9-11.16l1.69-2.48c4.51 3.08 7.2 8.18 7.2 13.64 0 9.11-7.41 16.52-16.52 16.52Z" />
    <path d="M22.5 6h3v19.95h-3z" />
  </svg>
);
export default SvgStandby;
